import { useDevice } from "../../useDevice";
import Box from "../Box";
import {
	CmeCertificateCard,
	type CmeCertificateCardProps,
} from "./CmeCertificateCard";
import { CmeStatusCard, type CmeStatusCardProps } from "./CmeStatusCard";
import type { CmeTabState } from "./types";

type Props =
	| ({ state: Exclude<CmeTabState, "ready"> } & CmeStatusCardProps)
	| ({ state: "ready" } & CmeCertificateCardProps);

const CmeTabCard = (props: Props) => {
	if (props.state === "ready") {
		const { state: _state, ...cardProps } = props;
		return <CmeCertificateCard {...cardProps} />;
	}
	const { state: _state, ...cardProps } = props;
	return <CmeStatusCard {...cardProps} />;
};

export const CmeTabContent = (props: Props) => {
	const { isMobile } = useDevice();

	return (
		<Box
			paddingHorizontal={isMobile ? 16 : 0}
			paddingTop={24}
			paddingBottom={24}
		>
			<CmeTabCard {...props} />
		</Box>
	);
};
